const formatNumber = (number, locale) => new Intl.NumberFormat(locale).format(number);

export default formatNumber;
